import {
  PresenceRulesPayload,
  PresenceRulesRequest,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

/**
 * Replaces one camera's rules. The request carries cameraId, so rules for
 * other cameras and unscoped rules are left alone by the backend.
 */
export function useUpdatePresenceRules(
  camId: string,
  onSuccess?: (payload: PresenceRulesPayload) => void
) {
  const url = `/v2/orm/presence/rules`;
  const request = new Request(url, { method: 'PUT' });

  return useAuthenticatedMutation<PresenceRulesPayload, PresenceRulesRequest>(
    request,
    {
      responseModifier: async (response) => {
        const respJson = await response.json();
        return respJson.payload;
      },
      onSuccessInvalidationKeys: [['presence-rules', camId]],
      onSuccess,
    }
  );
}

export default useUpdatePresenceRules;
